import { Exclude } from "class-transformer";
import { Column, Entity, JoinColumn, ManyToOne } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { CxCoupon } from "./cx-coupon.entity";
import { CxQuestionHeader } from "./cx-question-header.entity";
// import { Shop } from "./shop.entity";
// CxShopTokenはBranchesに紐づく
import { Branches } from "./branches.entity";

@Entity()
export class CxShopToken extends CommonColumns {

  @Exclude()
  @Column({ unique: true, length: 20, })
  token: string;

  @Exclude()
  @Column()
  memo1: string;

  @Exclude()
  @Column()
  memo2: string;

  @Column()
  disabled: boolean;

  // @ManyToOne(() => Shop, shop => shop.tokens, { nullable: true, })
  // @JoinColumn({ name: 'shop_id', referencedColumnName: 'id', })
  // shop: Shop|null;

  // @Column({ name: 'shop_id', nullable: true, })
  // shop_id: number|null;
  // CxShopTokenはBranchesに紐づく
  @ManyToOne(() => Branches, branch => branch.cxShopTokens, { nullable: true, })
  @JoinColumn({ name: 'branch_id', referencedColumnName: 'id', })
  branch: Branches|null;

  @Column({ name: 'branch_id', nullable: true, })
  branch_id: number|null;

  // @ManyToOne(
  //   () => QuestionHeader,
  //   questionHeader => questionHeader.shopTokens,
  //   {
  //     nullable: true,
  //   },
  // )
  // @JoinColumn({ name: 'question_header_id', referencedColumnName: 'id', })
  // questionHeader: QuestionHeader|null;

  // @Column({ name: 'question_header_id', nullable: true, })
  // question_header_id: number|null;
  // CxQuestionHeaderはBranchesの所属するCxBrandを介してCxQuestionHeaderと紐づく

  // クーポンは店舗ごとに柔軟な設定ができるようにしたい
  // CxBrandに紐づけると融通が効かなくなり、店舗ごとに個別のクーポンを発行できなくな困る
  // 上記の理由からクーポンはQRコードに紐づかせる
  @ManyToOne(() => CxCoupon, { nullable: true, })
  @JoinColumn({ name: 'cx_coupon_id', referencedColumnName: 'id', })
  cxCoupon: CxCoupon|null;

  @Column({ name: 'cx_coupon_id', nullable: true, })
  cxCouponId: number|null;

  constructor(props: TCxShopToken) {
    super();
    Object.assign(this, props);
  }
}

export declare type TCxShopToken = Omit<CxShopToken, 'dummy-no-such-field'>;
export interface ICxShopToken extends TCxShopToken {};
